import { ReactComponent as DownloadIcon } from 'assets/icons/download_circle.svg';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { useRegion } from 'common/hooks/region';
import { useSegment } from 'common/hooks/segment';
import Button from 'components/customDesign/Button';
import { downloadSnapshotPDF } from 'ducks/backupBank';
import { DateTime } from 'luxon';
import React from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { SnapshotUrl } from 'types/Shipping';
import { TERMINAL_SCREENSHOTS_PARAMS } from '../params';

interface Props {
  snapshot: SnapshotUrl;
}

export const Download: React.FC<Props> = (props) => {
  const { snapshot } = props;
  const region = useRegion();
  const { track } = useSegment();
  const { searchParams } = useCustomSearchParams(TERMINAL_SCREENSHOTS_PARAMS);

  const dispatch = useDispatch();

  const isLoading = useSelector((state: RootStateOrAny) => state.loader.downloadBackup);

  const handleClick = () => {
    track(
      'Terminal Screenshot Downloaded',
      {
        origin: 'terminal-screenshots',
        success: true,
        error: '',
        searchMethod: searchParams.mode === 'terminal' ? 'terminal' : 'ssl',
      },
      { includeUser: true }
    );
    const datetime = DateTime.fromFormat(
      `${snapshot.date} ${snapshot.time}`,
      'yyyy-MM-dd HH:mm'
    ).setZone(region.timeZone);
    const fileName = `${snapshot.terminal} ${datetime.toFormat('yyyy-mm-dd HH:mm ZZZZ')}`;
    dispatch(downloadSnapshotPDF(snapshot.key, fileName));
  };

  return (
    <Button
      onClick={handleClick}
      isLoading={isLoading}
      rightIcon={<DownloadIcon className="ml-1" />}
    >
      Get screenshot
    </Button>
  );
};
